import React from 'react'

export default function LinkedInIcon() {
   return (
      <svg
         width="49"
         height="49"
         viewBox="0 0 49 49"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
      >
         <path
            d="M24.2773 0.550293C11.0246 0.550293 0.277344 11.2975 0.277344 24.5503C0.277344 37.8031 11.0246 48.5503 24.2773 48.5503C37.5301 48.5503 48.2773 37.8031 48.2773 24.5503C48.2773 11.2975 37.5301 0.550293 24.2773 0.550293ZM17.3033 36.8315H11.4582V19.2465H17.3032L17.3033 36.8315ZM14.3808 16.8452H14.3428C12.3813 16.8452 11.1128 15.495 11.1128 13.8075C11.1128 12.0819 12.4201 10.769 14.4197 10.769C16.4192 10.769 17.6497 12.0819 17.6877 13.8075C17.6877 15.495 16.4192 16.8453 14.3808 16.8453V16.8452ZM38.3795 36.8315H32.5351V27.4239C32.5351 25.0597 31.6888 23.4472 29.5739 23.4472C27.9593 23.4472 26.9977 24.5349 26.5751 25.5848C26.4205 25.9606 26.3828 26.4858 26.3828 27.0112V36.8315H20.538C20.538 36.8315 20.6146 20.8962 20.538 19.2465H26.3828V21.7363C27.1595 20.5382 28.5493 18.8338 31.6504 18.8338C35.496 18.8338 38.3795 21.347 38.3795 26.7483V36.8315Z"
            fill="#F1ECDC"
         />
      </svg>
   )
}
